// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/frontend-asset-dist/css/" + chunkId + "." + "5d204972" + ".css";
};